import api from './api';
import types from './mutation-types';

export default {
	getPlants_({ commit }) {
		return api
			.getPlants()
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'plants',
				// 		value: data !== null && data !== undefined ? data.body : null
				// 	});
				// }
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'plants',
						value: data !== null && data !== undefined ? data.body : null
					});

					commit(types.SEARCH_PARAM, {
						key: 'plantCd',
						value: data.body.length > 0 ? data.body[0].commCd : ''
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getCommCodes_({ commit, state }, { key, codeType }) {
		state.searchParams.codeType = codeType;
		return api
			.getCommCodes(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: key,
				// 		value: data !== null && data !== undefined ? data.body : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: key,
						value: data !== null && data !== undefined ? data.body : null
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		// console.log('actions');
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	getDicMsgManagements_({ commit, state }, { currentPage, pageUnit }) {
		const { searchParams } = state;

		return api
			.getDicMsgManagements({ searchParams, currentPage, pageUnit })
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'dicMsgManagements',
				// 		value: data !== null && data !== undefined ? data.body.resultList : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'dicMsgManagements',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'popup',
						value: {
							groups: data.body.pagingInfo
						}
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getScreens_({ commit, state }, payload) {
		return api
			.getScreens(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					commit(types.TREE_LIST, body);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	getMenuTree_({ commit, state }) {
		let searchParams = {
			plantCd: state.searchParams.plantCd,
			msgLang: state.searchParams.msgLang,
			useYn: 'Y'
		};
		return api
			.getMenus({ searchParams })
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.TREE_LIST, data !== null && data !== undefined ? data.body.resultList : null);
				// }

				if (data.header.code === 0) {
					commit(types.TREE_LIST, data !== null && data !== undefined ? data.body.resultList : null);
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	// promise 방식 sample
	getMenus_({ commit, state }, { currentPage, pageUnit }) {
		const { searchParams } = state;

		return api
			.getMenus({ searchParams, currentPage, pageUnit })
			.then(data => {
				// console.log('@@@@ here then: ', data);

				if (data.header.code === 0) {
					// 기존 정상 처리
					commit(types.MENU_LIST, data !== null && data !== undefined ? data.body.resultList : null);
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
					// http status 는 성공이지만 내부적으로 오류일경우 catch 로 빠지게 하는식으로?
					// throw data
					commit(types.MENU_LIST, data !== null && data !== undefined ? data.body.resultList : null);
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				// console.log('@@@@ here catch: ', error);
				throw error.header ? error.header : error;
			});
	},
	getMenuKey_({ commit, state }, param) {
		return api
			.getMenuKey(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'menuKey',
				// 		value: data !== null && data !== undefined ? data.body : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'menuKey',
						value: data !== null && data !== undefined ? data.body : null
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setMenus_({ commit }, param) {
		return api
			.postMenus(param)
			.then(data => {
				// if (!data.body || data.header.code !== 200) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'menuKey',
				// 		value: null
				// 	});
				// 	return data.header;
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'menuKey',
						value: null
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSelectedMenu_({ commit, state }, param) {
		commit(types.SELECTED_MENU, param);
	},
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, {
			key,
			value
		});
	}
};
